import { useDraggable } from '@dnd-kit/core';
import type { ComponentCatalogItem } from '@calculom/report-designer';

interface PaletteTileProps {
  item: ComponentCatalogItem;
}

export function PaletteTile({ item }: PaletteTileProps) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: item.id,
    data: {
      type: 'palette-item',
      catalogId: item.id,
    },
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={`
        px-3 py-2 bg-white border border-gray-200 rounded-lg cursor-grab
        hover:border-blue-300 hover:shadow-sm transition-all select-none
        ${isDragging ? 'opacity-50' : ''}
      `}
    >
      <div className="text-sm font-medium text-gray-800">{item.name}</div>
      <div className="text-xs text-gray-500">{item.description}</div>
    </div>
  );
}
